import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { sessionEmail } from '../session-email';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // JWT travels as an httpOnly cookie (domain=.osmosapp.com) on deployed environments.
    // The browser sends it automatically to every *.osmosapp.com service via withCredentials: true.
    //
    // On localhost: cookies don't cross ports, so we fall back to reading the token from
    // localStorage and sending it as an Authorization: Bearer header.

    let google_request: any = request.url;
    if (google_request.includes('www.googleapis.com/calendar/')) {
      return next.handle(request);
    }

    let merchantId = localStorage.getItem('merchant_id');
    let userId = localStorage.getItem('userId');
    // Card #381: the same resolution sign-in, the workspace switch and sign-out use, so this
    // header always names the Redis session they created (or remove).
    const email = sessionEmail();
    let deviceLoginId = localStorage.getItem('deviceLoginId') || localStorage.getItem('osmos_deviceLoginId_stable');

    if (!merchantId || !userId) {
      try {
        const loginUserValue = JSON.parse(localStorage.getItem('loginUserValue') || '{}');
        if (!merchantId) {
          merchantId = loginUserValue?.merchant_id || loginUserValue?.merchantId || localStorage.getItem('create-session') || localStorage.getItem('redirect-merchant');
        }
        if (!userId) {
          userId = loginUserValue?.id || loginUserValue?.userId;
        }
      } catch (e) {}
    }

    let headersMap = request.headers
      .set('merchantId', merchantId ? `${merchantId}` : '')
      .set('x-user-id', userId ? `${userId}` : '')
      .set('email', email ? `${email}` : '')
      .set('deviceLoginId', deviceLoginId ? `${deviceLoginId}` : '')
      .set('clientdate', (new Date().toLocaleDateString('en-CA')).toString());

    const clonedRequest = request.clone({
      headers: headersMap,
      withCredentials: true
    });

    return next.handle(clonedRequest);
  }


}
